/* ------------------------------------------------
第一部分：引入基本常量-
--------------------------------------------------*/
window.DESKTOP_TO_MOBILE = 992; // 定义屏幕宽度转换为手机屏幕宽度的阈值
//import "./_js/_page_scale"// 支持页面放大缩小功能
//import "./_js/cms.all"  // 迅睿CMS基本js文件引用打包
/* ------------------------------------------------
第二部分：基本配置设置-统一布局-必须
--------------------------------------------------*/
import "./_js/_tab"// tab样式支持
import "./_js/_dialog"// 弹出对话框
import "./_js/_collapse"//折叠面板
import "./_js/_animate-number"//数字动态增长特效
import "./_js/_scroll" // #平滑滚动
import "./_js/_scroll-bar" //右侧悬浮框样式
import "./_js/_scroll-menu"  //可横向滚动栏目
import "./_js/_main-menu" // 顶部
import "./_js/_lang"  //语言下拉菜单切换
//import "./_js/_custom" // 自定义js文件
/* ------------------------------------------------
第二部分：美眼仪样式
--------------------------------------------------*/
import "./_js/_product_meiyan"  //美眼仪样式
import "./_js/_product_ruyi"  //玉如意样式

/* ------------------------------------------------
第三部分：自定义内容
--------------------------------------------------*/
// 引入itemStepSwitcher
import itemStepSwitcher from "./_js/_helpers/_step-switcher";
// 引入滑动背景构建工具
import scrollBackground from "./_js/_helpers/_scroll-background";
// 注册itemStepSwitcher到全局变量，以便在其他地方调用，如html页面中
window.itemStepSwitcher = itemStepSwitcher;
import { FixedScreen } from "./_js/_fixedscreen";
$(function () {
    // 美眼仪切换效果
    const mytest = new scrollBackground(".meiyan-test .switcher-group", {
        totalTime: 800, // 总切换时间
        usePseudoElement: 'after', 
        animationDurationVar: "--custom-animation-duration", // 自定义 CSS 变量名
    });

    // 美眼仪切换效果
    const myrf = new scrollBackground(".meiyan-rf .switcher-group", {
        totalTime: 800, // 总切换时间
        animationDurationVar: "--custom-animation-duration", // 自定义 CSS 变量名
    });

    // 产品副标题切换效果
    const productmenu = new scrollBackground(".product-submenu .switcher-group", {
        totalTime: 800, // 总切换时间
        animationDurationVar: "--custom-animation-duration", // 自定义 CSS 变量名
    });

    const width = window.innerWidth;
    if (width <= DESKTOP_TO_MOBILE) {
        // 手机端固定导航栏
        const fixedScreen = new FixedScreen('.fixedscreen',{
            offset:70
        });
    } else {
        // 非手机端固定导航栏
        const fixedScreen = new FixedScreen('.fixedscreen',{
            offset:90
        });
    }
});